import * as yup from 'yup';

export const FIELD_EXPLANATION = 'explanation';

export const AttestationAbsentValidationForm = yup.object().shape({
  explanation: yup.string().required('error.required').trim(),
});
